import React from 'react';
import { motion } from 'framer-motion';
type AuraProps = {
  className?: string;
  variant?: 'glow' | 'soft';
  drift?: boolean;
  delay?: number;
};
/**
 * The signature Aenigma visual: a large soft glowing orb of light
 * blooming out of pure black. Slowly pulses/drifts for a living feel.
 */
export function Aura({
  className = '',
  variant = 'glow',
  drift = true,
  delay = 0
}: AuraProps) {
  const base = variant === 'glow' ? 'aura-glow' : 'aura-glow-soft';
  if (!drift) {
    return <div aria-hidden="true" className={`pointer-events-none absolute ${base} ${className}`} data-id="element-6" />;
  }
  return <motion.div aria-hidden="true" className={`pointer-events-none absolute ${base} ${className}`} initial={{
    opacity: 0.55,
    scale: 0.96
  }} animate={{
    opacity: [0.55, 0.85, 0.55],
    scale: [0.96, 1.04, 0.96]
  }} transition={{
    duration: 9,
    delay,
    repeat: Infinity,
    ease: 'easeInOut'
  }} data-id="element-7" />;
}